/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { LogoResource } from './';
import {
    LogoResourceFromJSON,
    LogoResourceFromJSONTyped,
    LogoResourceToJSON,
} from './';
import type { PostalAddress } from './';
import {
    PostalAddressFromJSON,
    PostalAddressFromJSONTyped,
    PostalAddressToJSON,
} from './';
import type { RecommendationResource } from './';
import {
    RecommendationResourceFromJSON,
    RecommendationResourceFromJSONTyped,
    RecommendationResourceToJSON,
} from './';
import type { Skill } from './';
import {
    SkillFromJSON,
    SkillFromJSONTyped,
    SkillToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExperienceResource
 */
export interface ExperienceResource {
    /**
     * 
     * @type {string}
     * @memberof ExperienceResource
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceResource
     */
    origin?: ExperienceResourceOriginEnum;
    /**
     * 
     * @type {string}
     * @memberof ExperienceResource
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceResource
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceResource
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceResource
     */
    companyId?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceResource
     */
    organizationName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExperienceResource
     */
    hasProject?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExperienceResource
     */
    recommendationCount?: number;
    /**
     * 
     * @type {ActivityArea}
     * @memberof ExperienceResource
     */
    area?: ActivityArea;
    /**
     * 
     * @type {Date}
     * @memberof ExperienceResource
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExperienceResource
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ExperienceResource
     */
    currentJob?: boolean;
    /**
     * 
     * @type {PostalAddress}
     * @memberof ExperienceResource
     */
    location?: PostalAddress;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExperienceResource
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof ExperienceResource
     */
    skills?: Array<Skill>;
    /**
     * 
     * @type {Array<RecommendationResource>}
     * @memberof ExperienceResource
     */
    recos?: Array<RecommendationResource>;
    /**
     * 
     * @type {boolean}
     * @memberof ExperienceResource
     */
    asFreelance?: boolean;
    /**
     * 
     * @type {LogoResource}
     * @memberof ExperienceResource
     */
    logo?: LogoResource;
}


/**
 * @export
 */
export const ExperienceResourceOriginEnum = {
    Profile: 'PROFILE',
    Resume: 'RESUME'
} as const;
export type ExperienceResourceOriginEnum = typeof ExperienceResourceOriginEnum[keyof typeof ExperienceResourceOriginEnum];


/**
 * Check if a given object implements the ExperienceResource interface.
 */
export function instanceOfExperienceResource(value: object): value is ExperienceResource {
    return true;
}

export function ExperienceResourceFromJSON(json: any): ExperienceResource {
    return ExperienceResourceFromJSONTyped(json, false);
}

export function ExperienceResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'description': json['description'] == null ? undefined : json['description'],
        'title': json['title'] == null ? undefined : json['title'],
        'company': json['company'] == null ? undefined : json['company'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'hasProject': json['hasProject'] == null ? undefined : json['hasProject'],
        'recommendationCount': json['recommendationCount'] == null ? undefined : json['recommendationCount'],
        'area': json['area'] == null ? undefined : ActivityAreaFromJSON(json['area']),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'currentJob': json['currentJob'] == null ? undefined : json['currentJob'],
        'location': json['location'] == null ? undefined : PostalAddressFromJSON(json['location']),
        'tags': json['tags'] == null ? undefined : json['tags'],
        'skills': json['skills'] == null ? undefined : ((json['skills'] as Array<any>).map(SkillFromJSON)),
        'recos': json['recos'] == null ? undefined : ((json['recos'] as Array<any>).map(RecommendationResourceFromJSON)),
        'asFreelance': json['asFreelance'] == null ? undefined : json['asFreelance'],
        'logo': json['logo'] == null ? undefined : LogoResourceFromJSON(json['logo']),
    };
}

export function ExperienceResourceToJSON(value?: ExperienceResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'origin': value['origin'],
        'description': value['description'],
        'title': value['title'],
        'company': value['company'],
        'companyId': value['companyId'],
        'organizationName': value['organizationName'],
        'hasProject': value['hasProject'],
        'recommendationCount': value['recommendationCount'],
        'area': ActivityAreaToJSON(value['area']),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString().substring(0,10)),
        'currentJob': value['currentJob'],
        'location': PostalAddressToJSON(value['location']),
        'tags': value['tags'],
        'skills': value['skills'] == null ? undefined : ((value['skills'] as Array<any>).map((v) => SkillToJSON(v))),
        'recos': value['recos'] == null ? undefined : ((value['recos'] as Array<any>).map((v) => RecommendationResourceToJSON(v))),
        'asFreelance': value['asFreelance'],
        'logo': LogoResourceToJSON(value['logo']),
    };
}

